/**
 * Resolves the WHEP session URL from the POST response's `Location` header.
 *
 * MediaMTX returns a root-relative path (`/<path>/whep/<id>`) and does not know about a
 * prefix the edge proxy strips (the POST goes to `/stream/<path>/whep`). Resolving that
 * against the host root drops the prefix, so the DELETE hits an unrouted path and the
 * proxy's 404 surfaces as a CORS error. When the POST path ends with the session's parent
 * path, the stripped prefix is restored; otherwise `Location` is resolved as usual.
 */
export const resolveWhepResourceUrl = ({
  location,
  whepUrl,
}: {
  location: string;
  whepUrl: string;
}): string => {
  const resolved = new URL(location, whepUrl);
  if (!location.startsWith('/') || location.startsWith('//')) return resolved.href;

  const whep = new URL(whepUrl);
  const whepPath = whep.pathname.replace(/\/+$/, '');
  const sessionParentPath = resolved.pathname.slice(0, resolved.pathname.lastIndexOf('/'));
  if (!sessionParentPath || whepPath === sessionParentPath) return resolved.href;
  if (!whepPath.endsWith(sessionParentPath)) return resolved.href;

  const strippedPrefix = whepPath.slice(0, -sessionParentPath.length);
  return new URL(`${strippedPrefix}${resolved.pathname}${resolved.search}`, whep.origin).href;
};
